import styled from 'styled-components';

import { ThumbnailType } from '../constants';
import { StyleColor, NewStyleColor, Format } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';

interface WrapperProps {
	type: ThumbnailType;
	isActive: boolean;
	isBlurred: boolean;
	itemsInRow?: number | 'AUTO';
}

interface IconCheckProps {
	isChecked: boolean;
}

const Wrapper = styled('li')`
	box-sizing: border-box;
	position: relative;
	padding: 12px;
	padding-bottom: 6px;
	background-color: ${({ isActive }: WrapperProps) => isActive ? StyleColor.Blue600 : NewStyleColor.Grey900};
	font-family: HelveticaNeue, sans-serif;
	color: ${StyleColor.White};
	cursor: default !important;
	user-select: none;

	${({ isBlurred }: WrapperProps) => isBlurred && 'opacity: 0.05;'}

	${({ type }: WrapperProps) => type === ThumbnailType.COLUMN && `
		border-bottom: 1px solid ${NewStyleColor.Grey900};
	`}

	${({ type, itemsInRow }: WrapperProps) => type === ThumbnailType.GRID && itemsInRow && `
		margin: 0 15px;
		margin-bottom: 7px;
		border-radius: 4px;

		${getGridItemWidth(itemsInRow)};
	`}
`;

const getGridItemWidth = (itemsInRow: number | 'AUTO'): string => {
	if (itemsInRow === 'AUTO') {
		return `
			width: calc(50% - 30px);

			@media ${Format.SmartphoneLandscape}, ${Format.Tablet} {
				width: calc(33.33% - 30px);
			}

			@media ${Format.SmallDesktop} {
				width: calc(25% - 30px);
			}

			@media ${Format.MediumDesktop} {
				width: calc(20% - 30px);
			}

			@media ${Format.LargeDesktop} {
				width: calc(16.66% - 30px);
			}
		`;
	}

	return `width: calc(${100 / itemsInRow}% - 30px)`;
};

const Inner = styled('div')`
	&:focus {
		outline: 0;
	}
`;

const SelectedNumber = styled('div')`
	position: absolute;
	top: -5px;
	right: -5px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border: 2px solid currentColor;
	border-radius: 50%;
	background-color: ${StyleColor.White};
	font-weight: 700;
	font-size: 10px;
	color: ${StyleColor.Blue600};
`;

const iconCommonStyles = `
	box-sizing: border-box;
	position: absolute;
	top: 20px;
	right: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	box-shadow: 0 0 5px 0 ${hexToRgba(StyleColor.Black, 12)};
`;

const IconEdit = styled('div')`
	${iconCommonStyles}
	border: 2px solid ${StyleColor.White};
	background-color: ${StyleColor.Black};

	svg {
		width: 18px;
		height: 18px;
		fill: ${StyleColor.White};
	}
`;

const IconReference = styled('div')`
	${iconCommonStyles}
	border: 2px solid ${StyleColor.White};
	background-color: ${StyleColor.Black};

	svg {
		width: 18px;
		height: 18px;
		fill: ${StyleColor.White};
	}
`;

const IconCheck = styled('div')`
	${iconCommonStyles}
	border: 2px solid ${({ isChecked }: IconCheckProps) => isChecked ? NewStyleColor.Blue450 : NewStyleColor.White};
	background-color: ${hexToRgba(StyleColor.Grey200, 20)};

	${({ isChecked }: IconCheckProps) => isChecked && `
		&::after {
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 14px;
			height: 14px;
			border-radius: 50%;
			background-color: ${NewStyleColor.Blue450};
		}
	`}
`;

export {
	Wrapper,
	Inner,
	SelectedNumber,
	IconEdit,
	IconCheck,
	IconReference,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Thumbnails/Item/styles.ts